import { valueAddedServices } from '@/mocks/homeData';

export default function ValueAddedServices() {
  return (
    <section className="py-20 md:py-28 bg-[#F7F9FC]">
      <div className="section-container">
        <div className="text-center mb-14 animate-on-scroll">
          <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium mb-5">
            Value Added Services
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-800 mb-3">
            Beyond Manufacturing
          </h2>
          <p className="text-foreground-500 max-w-[560px] mx-auto leading-relaxed">
            Comprehensive in-house services that add value at every stage — from design development to final packaging.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-4">
          {valueAddedServices.map((service, i) => (
            <div
              key={i}
              className={`bg-white rounded-lg p-5 border border-[#E6EAF0] hover:border-primary-200 hover:shadow-sm transition-all duration-300 text-center group animate-on-scroll animate-on-scroll-delay-${(i % 5) + 1}`}
            >
              <div className="w-10 h-10 mx-auto rounded-lg bg-primary-50 flex items-center justify-center mb-3 group-hover:bg-primary-100 transition-colors">
                <i className={`${service.icon} text-primary-500 text-lg`}></i>
              </div>
              <h3 className="text-xs font-heading font-semibold text-foreground-800 mb-1.5 whitespace-nowrap">
                {service.title}
              </h3>
              <p className="text-[11px] text-foreground-500 leading-relaxed line-clamp-2">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}